module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "login"
    }
  }, [_c('div', {
    staticClass: "loginBg"
  }), _vm._v(" "), _c('div', {
    staticClass: "logoImg"
  }), _vm._v(" "), _c('div', {
    staticClass: "loginContent"
  }, [_c('div', {
    staticClass: "loginForm"
  }, [_vm._m(0), _vm._v(" "), _c('i-form', {
    ref: "formLogin",
    staticClass: "card-box",
    attrs: {
      "model": _vm.formLogin,
      "rules": _vm.formLoginRules,
      "autocomplete": "on"
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "username"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formLogin.username),
      expression: "formLogin.username"
    }],
    staticClass: "ivu-input",
    attrs: {
      "size": "large",
      "type": "text",
      "placeholder": _vm.language.yonghuming
    },
    domProps: {
      "value": (_vm.formLogin.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formLogin, "username", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "userIcon"
  })]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formLogin.password),
      expression: "formLogin.password"
    }],
    staticClass: "ivu-input",
    attrs: {
      "type": "password",
      "placeholder": _vm.language.mima
    },
    domProps: {
      "value": (_vm.formLogin.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formLogin, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "lockIcon"
  })]), _vm._v(" "), _c('Form-item', {
    staticClass: "login-no-bottom"
  }, [_c('i-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.handleSubmit('formLogin')
      }
    }
  }, [_vm._v(_vm._s(_vm.language.denglu))])], 1)], 1), _vm._v(" "), _c('button', {
    staticClass: "wangji",
    on: {
      "click": _vm.forget
    }
  }, [_vm._v(_vm._s(_vm.language.wangjimima))])], 1), _vm._v(" "), _c('Modal', {
    model: {
      value: (_vm.modal),
      callback: function($$v) {
        _vm.modal = $$v
      },
      expression: "modal"
    }
  }, [_c('Table', {
    ref: "selection",
    attrs: {
      "border": "",
      "columns": _vm.columns,
      "data": _vm.organization,
      "highlight-row": true
    },
    on: {
      "on-row-click": _vm.getSelected
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "long": ""
    },
    on: {
      "click": function($event) {
        _vm.getSelection(_vm.selectedCom.segNo)
      }
    }
  }, [_vm._v(_vm._s(_vm.language.queding))])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "320px"
    },
    model: {
      value: (_vm.modalInfo),
      callback: function($$v) {
        _vm.modalInfo = $$v
      },
      expression: "modalInfo"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("选择公司失败，请重新登录")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "type": "primary",
      "long": ""
    },
    on: {
      "click": _vm.loginError
    }
  }, [_vm._v(_vm._s(_vm.language.queding))])], 1)])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titleuser"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/titleuser.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6fd1762a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Login/index.vue
// module id = 925
// module chunks = 1